import { Injectable, ErrorHandler } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { HttpHelper, Url } from 'src/app/common';




@Injectable()
export class UploadService {

  url = Url.apiUrl;

  constructor(private httpClient: HttpClient, private http: HttpHelper) {

  }

  postEmail(param): Observable<any> {
    return this.http.postOutSite('https://smileehealth.eu/home?na=s', param ).pipe(retry(3), catchError(this.handleError));
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }


}
